export default __webpack_public_path__ + "static/media/notes-image.f46ec998.svg";